import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import { preserveQueryParams } from 'utils/js/browser_helpers'
import { imgErrNHL } from './../../utils/js/nhl_helpers'

import './PlayerHead.scss'

const PlayerHead = ({
    imageUrl,
    imageWidth,
    mediumSizing,
    animate = true,
    splashAnimation = true,
    isLoading,
    imageOnErrorFallback,
    circleColor,
    circleColorClassName,
    playerUrl,
}) => {
    let cont_style = {}
    let player_style = {}
    let circle_style_top = {}
    let circle_style_bottom = {}
    let sizing_class = ''

    if (imageWidth) {
        cont_style = {
            style: { width: `${imageWidth}px`, height: `${imageWidth}px` },
        }
        ;(player_style = {
            style: {
                width: `${imageWidth}px`,
                height: `${imageWidth + 20}px`,
            },
        }),
            (circle_style_top = {
                style: {
                    borderColor: circleColor,
                    borderWidth: `2px`,
                    width: `${imageWidth}px`,
                    height: `${imageWidth / 2}px`,
                    borderTopLeftRadius: `${imageWidth / 2 + 2}px`,
                    borderTopRightRadius: `${imageWidth / 2 + 2}px`,
                },
            }),
            (circle_style_bottom = {
                style: {
                    borderColor: circleColor,
                    borderWidth: `2px`,
                    width: `${imageWidth}px`,
                    height: `${imageWidth / 2}px`,
                    borderBottomLeftRadius: `${imageWidth / 2 + 2}px`,
                    borderBottomRightRadius: `${imageWidth / 2 + 2}px`,
                },
            })
    } else if (mediumSizing) {
        sizing_class = 'medium'
    }

    let animatingSplashClass = ''

    if (animate && !isLoading) {
        animatingSplashClass = 'splashed'
    }

    return (
        <div className={`PlayerHead__cont ${sizing_class}`}>
            <div className="player_image_cont" {...cont_style}>
                {splashAnimation && <div className={`circle_splash ${animatingSplashClass}`} />}
                <div className={`circle_top ${circleColorClassName}`} {...circle_style_top} />

                <div className="player" {...player_style}>
                    <CSSTransitionGroup
                        transitionName="player_img__ani"
                        transitionAppear={animate ? true : false}
                        transitionAppearTimeout={500}
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}
                    >
                        <a href={preserveQueryParams(playerUrl)}>
                            <img
                                key={imageUrl}
                                className="player_img"
                                src={imageUrl}
                                alt=""
                                onError={imageOnErrorFallback ? imageOnErrorFallback : imgErrNHL}
                            />
                        </a>
                    </CSSTransitionGroup>
                </div>
                <div className={`circle_bottom ${circleColorClassName}`} {...circle_style_bottom} />
            </div>
        </div>
    )
}

export default PlayerHead
